import { render, staticRenderFns } from "./person-info.vue?vue&type=template&id=5b341584&"
import script from "./person-info.vue?vue&type=script&lang=js&"
export * from "./person-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports